import loadable from "@loadable/component"
import PropTypes from "prop-types"

import { retry } from "helpers/application"

const JewelrySlideshow = loadable(() =>
  retry(() => import("./jewelry-slideshow"))
)

const LandingCodeRef = ({ element }) => {
  const { ref } = element.data || {}

  if (!ref) return null

  switch (ref) {
    case "jewelry-slideshow":
      return <JewelrySlideshow element={element} />
    default:
      return null
  }
}

LandingCodeRef.propTypes = {
  element: PropTypes.object,
}

export default LandingCodeRef
